export default "__VITE_ASSET__90929aeb__"